export function transformToFromElm(fromRef, toRef) {
    var fromElm = fromRef.current;
    var toElm = toRef.current;
    var fromRect = fromElm.getBoundingClientRect();
    var toRect = toElm.getBoundingClientRect();
    var deltaX = fromRect.x - toRect.x;
    var deltaY = fromRect.y - toRect.y;
    var scaleX = fromRect.width / toRect.width;
    var scaleY = fromRect.height / toRect.height;
    toElm.style.transform = "translate(" + deltaX + "px, " + deltaY + "px) scale(" + scaleX + ", " + scaleY + ")";
    toElm.style.transformOrigin = '0 0';
}
